const revenueRecognitionMethods = {
  invoiced: { id: 'invoiced', name: 'As Invoiced' },
  manual: { id: 'manual', name: 'Manual' },
  automated_hours: { id: 'automated_hours', name: 'Automated - Percentage of Billable Hours' },
  automated_tm_basis: { id: 'automated_tm_basis', name: 'Automated - Percentage of Time & Materials Revenue' },
};

export default revenueRecognitionMethods;
